import { withInstall } from '@lit-element/utils'

import Marquee from './src/marquee.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtMarquee: SFCWithInstall<typeof Marquee> = withInstall(Marquee)
export default LtMarquee

export * from './src/marquee'
